'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CreditCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
function CreditCard(props = {}) {
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, { inheritViewBox: true, ...props, children: (0, jsx_runtime_1.jsxs)("svg", { viewBox: "0 0 512 512", children: [(0, jsx_runtime_1.jsx)("path", { fill: "currentColor", d: "M472,72H40A24.028,24.028,0,0,0,16,96V416a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V96A24.028,24.028,0,0,0,472,72Zm-8,32v64H48V104ZM48,408V232H464V408Z" }), (0, jsx_runtime_1.jsx)("rect", { width: "64", height: "32", x: "88", y: "312", fill: "currentColor" }), (0, jsx_runtime_1.jsx)("rect", { width: "64", height: "32", x: "184", y: "312", fill: "currentColor" })] }) }));
}
